export interface ISmartUploadProcess {
  upload_id: string;
  application_id: string | null;
  name: string;
  status: SmartUploadProcessStatus;
}

export enum TxStatus {
  SubmissionInProgress = 'Submission_in_progress',
  Scheduled = 'Scheduled',
  Started = 'Started',
  Completed = 'Completed',
  Failed = 'Failed',
}

export enum SmartUploadProcessStatus {
  Completed = 'Completed',
  Extracting = 'Extracting',
  Processing = 'Processing',
  Failed = 'Failed',
}

export interface IUniversalSubmit {
  submission_id: string;
  submission_status: string;
  tenant_id: string;
  user_id: string;
  application_id: string;
  application_status: string;
  application_status_reason: string;
  tx_status: TxStatus;
}
export interface IInsuranceIntelligence {
  submission_id: string;
  submission_status: string;
  tenant_id: string;
  user_id: string;
  quote_application?: {
    tx_status: TxStatus;
    tx_id: string;
    application_id?: string;
  };
  document_processing: {
    tx_status: TxStatus;
  };
}
